import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeoService } from 'src/app/shared/services/angular-service/seo.service';
import { SocialService } from 'src/app/shared/services/angular-service/social.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';

@Component({
  selector: 'app-feed-probo-details',
  templateUrl: './feed-probo-details.component.html',
  styleUrl: './feed-probo-details.component.scss',
})
export class FeedProboDetailsComponent implements OnInit {

  postId;
  probo;

  constructor(
    private route: ActivatedRoute,
    private socialService: SocialService,
    private toastService: ToastService,
    private seoService: SeoService,
  ) {
    this.route.params.subscribe((params) => {
      this.postId = params.id;
      this.getPostById();
    });
  }

  ngOnInit() {
    this.seoService.getSeo('feed');
  }

  getPostById() {
    this.socialService
      .getProboPostById(this.postId)
      .then((data: any) => {
        this.probo = data;
      })
      .catch((err: any) => {
        console.log(err);
        this.toastService.addSingle(
          'error',
          'Error',
          err.message || 'Something Went wrong'
        );
      });
  }
}
